<div class="w-[572px]">
  <div class="pb-[18px]">
    <div class="v4-filter-list overflow-x-auto pb-[12px]">
      <div class="v4-filter-item" *ngFor="let group of houseGroupList; index as i" (click)="checkGroup(i)">
        <div class="v4-filter v4-filter-selectable" [class.selected]="group.check">{{ group?.name }}</div>
      </div>
    </div>
    <div class="v4-filter-list overflow-x-auto pb-[12px]">
      <div class="v4-filter-item" *ngFor="let type of houseTypeList; index as i" (click)="checkType(i)">
        <div class="v4-filter v4-filter-selectable" [class.selected]="type.check">
          {{ type?.title }}
        </div>
      </div>
    </div>
  </div>

  <div>
    <div *ngIf="allHouseList.length > 0; else empty">
      <div class="mb-[24px]" *ngFor="let houseType of allHouseList">
        <div class="text-m mb-[24px]" *ngIf="allHouseList.length !== 1">
          {{ houseType?.house_type_title }}
        </div>
        <div class="v4-filter-list flex-wrap">
          <div class="v4-filter-item pb-[12px]" *ngFor="let house of houseType?.houses" (click)="chooseHouse(house)">
            <div
              class="v4-filter v4-filter-selectable max-w-[350px]"
              [class.selected]="house.checked"
              [class.disabled]="house.disabled"
            >
              {{ house?.house_title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #empty>
      <div class="empty text-center">
        <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
        <p>
          <!-- 暂无房间 -->
          {{ "house_price.no_house" | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</div>
